<template>
  <main class="home">
    <ReportTable :units="units" v-if="units.length > 0 "/>
  </main>
</template>

<script>
// @ is an alias to /src
import ReportTable from '@/components/ReportTable.vue'
import axios from "axios";

export default {
  name: 'Report',
  components: {
    ReportTable
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn
    },
    authToken: function () {
      return this.$store.getters.authToken
    }
  },
  watch: {
    authToken: function (val) {
      console.log('changed',val)
      this.units = [];
      this.init();
    }
  },
  data() {
    return {
      units: []
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init: function() {
      this.getUnits(this.authToken)
          .then((getUnitsDetails) => {
            console.log('getUnits details', getUnitsDetails)
            if (getUnitsDetails.result) {
              this.units = getUnitsDetails.details.units;
              this.$store.dispatch('updateStatuses',getUnitsDetails.details.scheduleStatuses)
              this.$store.dispatch('updateProject', getUnitsDetails.details.name)
            }
          })
          .catch(err => {
            console.log('getUnits err',err)
            this.logout()
          })
    },
    getUnits: function (authToken) {
      return new Promise((resolve, reject) => {
        axios({
          url: 'https://admin.giraffapp.com/giraffweb_get_units_no_schedule?authToken=' + authToken,
          method: 'GET'
        }).then(resp => {
          // console.log('giraffweb_get_units response:', resp)
          if (resp.data.result) {
            const unitsData = resp.data
            resolve(unitsData)
          } else {
            reject('report GetUnits Failed')
          }

        }).catch(err => {
          reject(err)
        })
      })
    },
    logout: function () {
      this.$store.dispatch('logout')
          .then(() => {
            this.$router.push('/login')
          })
    }
  },
}
</script>
<style lang="sass" scoped>
</style>
